import axios from "axios";
import { getJson } from "./getJson";

export const getSheet = async (sheetId) => {
  const sheetApi =
    "https://script.google.com/macros/s/AKfycbzjHGLAqoWV1Zb1zpFolwkfKssZ9_oJ6O1Hrq7CfJS4Z5iEGyeCbwZ0pYgh6lNcQo0t/exec?sheetId=";
  return axios
    .get(`${sheetApi}${sheetId}`)
    .then((response) => {
      const data = response.data;
      console.log(data);
      return data;
    })
    .catch((error) => {
      console.error("Axios error:", error);
      return {};
    });
};

// 檢查當前網址是否為 localhost
const isLocalhost = window.location.hostname === "localhost";
// 動態設置路徑
const path = isLocalhost
  ? "../website_data.json"
  : "../vr/frontEnd/plugin/vr/website_data.json";
// 使用動態路徑獲取資料
export const googleSheet = await getJson(path);
